export default __webpack_public_path__ + "static/media/extracker.ff99f0b8.png";